import type { FC } from "react";

import { formatNumberByThousands } from "widgets/utils";

import type { EventResource } from "@/graphql.ts";
import { FileTile } from "@/modules/files/components/FileTile";
import { ContigTile, GenomeTile, GenomeViewTile } from "@/ui-modules/core/tiles";
import { FolderTile } from "@/ui-modules/core/tiles/components/FolderTile.tsx";

export const PlaybookEventResource: FC<{ eventResource: EventResource; resourceCategory?: string }> = ({
  eventResource,
  resourceCategory,
}) => {
  if (eventResource == undefined) return null;

  if (eventResource.file) {
    return <FileTile file={eventResource.file} type={resourceCategory} />;
  } else if (eventResource.folder) {
    return <FolderTile folder={eventResource.folder} type={resourceCategory} />;
  } else if (eventResource.organism) {
    return <GenomeTile genome={eventResource.organism} type={resourceCategory} />;
  } else if (eventResource.region) {
    const { contig, range } = eventResource.region;
    return (
      <>
        <ContigTile
          contig={contig}
          footNote={
            <>
              <strong>{contig.organism.name}</strong> (
              <span style={{ fontStyle: "italic" }}>{contig.organism.species.name}</span>)
            </>
          }
        />
        <GenomeViewTile
          title={`${range.start} – ${range.stop}`}
          to={`/contig/${contig.id}/genome?range=${range.start},${range.stop}`}
          footNote={`${formatNumberByThousands(range.stop - range.start + 1)} bp`}
        />
      </>
    );
  }

  return null;
};
